export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_06.662b28f7.jpg";